<script lang="ts">
  import HtmlStaticPage from '../../components/html-static-page/HtmlStaticPage.svelte'
  import i18n from '../../i18n'
  import * as contents from './content'

  const content = $derived(contents[$i18n.language as keyof typeof contents])
</script>

<HtmlStaticPage {content} />
